/**
 * Prizes list
 */

import $ from 'jquery';
import Vue from 'vue';

const tgesItemComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'tge-item',

    /**
     * Comonent data
     * @return {Object}
     */
    data () {
        const dataObject = {
            expanded: false,
            label: 'Read more'
        };

        return dataObject;
    },

    /**
     * Props & Data watcher
     * @type {Object}
     */
    watch: {
        expanded (expanded) {
            $(this.$refs.more).slideToggle(
                500,
                () => {
                    if (expanded) {
                        this.label = 'Hide text';
                    } else {
                        this.label = 'Read more';
                    }
                }
            );
        }
    },

    /**
     * Mounted event handler
     * @return {Void}
     */
    mounted () {
        console.log('Mounted: %s', this.name);
    }
};

const tgesItemComponent = Vue.extend(tgesItemComponentConfig);

export default tgesItemComponent;
